import React from "react";
import ResourceAdmin from "../../components/admin/ResourceAdmin";
import { adminApi } from "../../lib/api";

export default function GamificacionAdmin() {
  return (
    <ResourceAdmin
      title="Insignias"
      subtitle="Logros y recompensas de gamificación para los líderes."
      resource={adminApi.resource("insignias")}
      defaults={{ nombre: "", descripcion: "", puntos: 50, color: "#22A860", icono: "Sparkles" }}
      fields={[
        { name: "nombre", label: "Nombre", type: "text", placeholder: "Ej. Primer paso" },
        { name: "descripcion", label: "Descripción", type: "textarea", placeholder: "¿Cómo se gana esta insignia?" },
        { name: "puntos", label: "Puntos", type: "number" },
        { name: "color", label: "Color (hex)", type: "text", placeholder: "#22A860" },
        { name: "icono", label: "Icono (lucide)", type: "text", placeholder: "Sparkles" },
      ]}
      columns={[
        { name: "nombre", label: "Insignia", render: (i) => (
          <span className="inline-flex items-center gap-2 font-bold text-[#0A1C30]">
            <span className="w-3.5 h-3.5 rounded-full" style={{ background: i.color }} /> {i.nombre}
          </span>
        ) },
        { name: "descripcion", label: "Descripción" },
        { name: "puntos", label: "Puntos", render: (i) => `${i.puntos} pts` },
      ]}
    />
  );
}
